module.exports = __webpack_public_path__ + "img/feature_sy_bg.20a41d8d.png";